module.exports = __webpack_public_path__ + "img/about-04.9cab3045.jpg";